export default __webpack_public_path__ + "static/media/img-medium.ea9a0061.png";